if (!customElements.get("event-countdown")) {
    class EventCountdown extends HTMLElement {
        constructor() {
            super();
            this.countdownDate = this.dataset.date;
            this.timeDays = this.querySelector("#times_days");
            this.timeHours = this.querySelector("#times_hours");
            this.timeMinutes = this.querySelector("#times_mins");
            this.timeSeconds = this.querySelector("#times_seconds");
        }

        connectedCallback() {
            this.setCountdown();
        }

        get nowTime() {
            return new Date().getTime();
        }

        setCountdown() {
            if (!this.countdownDate) {
                // console.warn("倒计时时间缺失");
                return;
            }

            // 解析倒计时目标时间，并转换为 UTC 时间
            const targetTime = new Date(this.countdownDate).getTime();

            if (isNaN(targetTime)) {
                // console.error("倒计时时间解析失败:", this.countdownDate);
                return;
            }
            // console.log("倒计时时间解析成功");
            // 更新倒计时的函数
            const updateCountdown = () => {
                const now = this.nowTime;
                const timeDiff = targetTime - now;
                // console.log("现在时间:", now);
                // console.log("目标时间: ", targetTime);
                if (timeDiff <= 0) {
                    // 如果时间到达或已过，倒计时归零
                    this.timeDays.textContent = "00";
                    this.timeHours.textContent = "00";
                    this.timeMinutes.textContent = "00";
                    this.timeSeconds.textContent = "00";

                    clearInterval(this.countdownInterval);
                    console.log("Countdown finished");
                    return;
                }

                // 计算天、小时、分钟、秒
                const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
                const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

                // 更新倒计时 DOM
                this.timeDays.textContent = days.toString().padStart(2, "0");
                this.timeHours.textContent = hours.toString().padStart(2, "0");
                this.timeMinutes.textContent = minutes.toString().padStart(2, "0");
                this.timeSeconds.textContent = seconds.toString().padStart(2, "0");
            };

            // 先执行一次更新，确保倒计时立即显示正确的数值
            updateCountdown();

            // 每秒更新倒计时
            this.countdownInterval = setInterval(updateCountdown, 1000);
        }

        disconnectedCallback() {

        }
    }

    customElements.define('event-countdown', EventCountdown);
}